import React from "react";

const PaymentSuccess = () => {
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
  return (
    <div
      style={{ minHeight: "70vh" }}
      className="container  d-flex flex-column justify-content-center align-items-center text-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        fill="none"
        viewBox="0 0 24 24"
        stroke="green"
        strokeWidth="2"
        className="mb-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4m5 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>

      <h1 className="display-5 fw-bold text-success mb-3">
        Payment Successful
      </h1>
      <p className="lead text-muted">
        Thank you! Your transaction was completed successfully. You can now
        continue using the platform.
      </p>
    </div>
  );
};

export default PaymentSuccess;
